import { useEffect, useMemo, useRef, useState } from 'react'

import { DateUnit, parseTimeAgo } from '@/utils/dateFormat'

const useTimeAgo = (date: string | number | Date, toGMT = true, duration = DateUnit.Minute) => {
  const [now, setNow] = useState(Date.now())
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined)
  const displayDate = useMemo(() => {
    const { value, unit } = parseTimeAgo(date, toGMT, now)
    if (!unit) return value
    return `${value} ${unit} ago`
  }, [date, toGMT, now])
  useEffect(() => {
    if (duration <= 0) return
    timeoutRef.current = setTimeout(() => {
      setNow(Date.now())
    }, duration)
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [duration, now])
  return displayDate
}
export default useTimeAgo
